var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoMusicSlash = function SvgIcoMusicSlash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M64 432c0 44.2 43 80 96 80s96-35.8 96-80V297.7l-64-50.4v109.3c-10-3-20.8-4.6-32-4.6-53 0-96 35.8-96 80m128.1-306.7c36.2 28.4 72.4 56.7 108.6 85.1L512 147v145.5c-10-2.9-20.8-4.6-32-4.6-22.2 0-42.6 6.3-58.8 16.8 46.1 36.1 92.1 72.2 138.2 108.3 10.4-12.8 16.6-28.3 16.6-45V32c0-10.1-4.8-19.6-12.9-25.7C557.5 2.2 550.8 0 544 0c-3.1 0-6.2.4-9.2 1.3l-320 96c-12.7 3.8-21.6 14.9-22.7 27.9z",
    style: {
      opacity: 0.4
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1l-592-464C-1.2 34.7-3.1 19.6 5.1 9.2",
    className: "ico-music-slash_svg__fa-primary"
  })));
};
export default SvgIcoMusicSlash;